var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "card-container", style: { background: _vm.cardColor } },
    [
      _c("div", { staticClass: "item" }, [
        _c("div", { staticClass: "count", style: { color: _vm.countColor } }, [
          _vm._v(_vm._s(_vm.list && _vm.list[0] && _vm.list[0].count)),
        ]),
        _vm._v(" "),
        _c("div", { staticClass: "title", style: { color: _vm.titleColor } }, [
          _vm._v(_vm._s(_vm.list && _vm.list[0] && _vm.list[0].title)),
        ]),
      ]),
      _vm._v(" "),
      _c("div", { staticClass: "divider" }),
      _vm._v(" "),
      _c("div", { staticClass: "item" }, [
        _c("div", { staticClass: "count", style: { color: _vm.countColor } }, [
          _vm._v(_vm._s(_vm.list && _vm.list[1] && _vm.list[1].count)),
        ]),
        _vm._v(" "),
        _c("div", { staticClass: "title", style: { color: _vm.titleColor } }, [
          _vm._v(_vm._s(_vm.list && _vm.list[1] && _vm.list[1].title)),
        ]),
      ]),
      _vm._v(" "),
      _c("div", { staticClass: "divider" }),
      _vm._v(" "),
      _c("div", { staticClass: "item" }, [
        _c("div", { staticClass: "count", style: { color: _vm.countColor } }, [
          _vm._v(_vm._s(_vm.list && _vm.list[2] && _vm.list[2].count)),
        ]),
        _vm._v(" "),
        _c("div", { staticClass: "title", style: { color: _vm.titleColor } }, [
          _vm._v(_vm._s(_vm.list && _vm.list[2] && _vm.list[2].title)),
        ]),
      ]),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }